import { render } from "./factureType.vue?vue&type=template&id=2f9a39d0&scoped=true"
import script from "./factureType.vue?vue&type=script&lang=js"
export * from "./factureType.vue?vue&type=script&lang=js"

import "./factureType.vue?vue&type=style&index=0&id=2f9a39d0&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9a39d0"]])

export default __exports__